// Cousin Cycle — theme.js

document.addEventListener('DOMContentLoaded', function () {

  var currentColour = 'lilac';
  var currentSize = null;
  var productVariants = [];
  var quantity = 1;

  // Fetch product variants
  fetch('/products/cousin-jersey-t.json')
    .then(function(response) { return response.json(); })
    .then(function(data) {
      productVariants = data.product.variants;
      renderSizeSelector(data.product.variants);
      bindQuantityButtons();
      // Show first lilac image on load
      var firstImg = document.querySelector('.gallery-img[data-colour="lilac"]');
      if (firstImg) firstImg.classList.remove('hidden');
      var firstThumb = document.querySelector('.thumb[data-colour="lilac"]');
      if (firstThumb) firstThumb.classList.add('active');
    })
    .catch(function(err) {
      console.error('Could not fetch product variants', err);
    });

  // Bind quantity buttons
  function bindQuantityButtons() {
    var minusBtn = document.getElementById('qty-minus');
    var plusBtn = document.getElementById('qty-plus');
    var qtyEl = document.getElementById('qty-value');
    if (minusBtn && !minusBtn.dataset.bound) {
      minusBtn.dataset.bound = true;
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (quantity > 1) {
          quantity--;
          if (qtyEl) qtyEl.textContent = quantity;
        }
      });
    }
    if (plusBtn && !plusBtn.dataset.bound) {
      plusBtn.dataset.bound = true;
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        quantity++;
        if (qtyEl) qtyEl.textContent = quantity;
      });
    }
  }

  // Render size selector
  function renderSizeSelector(variants) {
    var sizes = [];
    variants.forEach(function(v) {
      if (sizes.indexOf(v.option1) === -1) sizes.push(v.option1);
    });
    var container = document.getElementById('size-selector');
    if (!container) return;
    sizes.forEach(function(size) {
      var btn = document.createElement('button');
      btn.className = 'size-btn';
      btn.textContent = size;
      btn.dataset.size = size;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        currentSize = size;
        updateAddToCart();
      });
      container.appendChild(btn);
    });
  }

  // Update Add to Cart button
  function updateAddToCart() {
    var btn = document.getElementById('add-to-cart-btn');
    if (!btn) return;
    if (!currentSize) {
      btn.textContent = 'Select a size';
      btn.disabled = true;
      return;
    }
    var colourName = currentColour.charAt(0).toUpperCase() + currentColour.slice(1);
    var variant = null;
    for (var i = 0; i < productVariants.length; i++) {
      if (productVariants[i].option1 === currentSize && productVariants[i].option2 === colourName) {
        variant = productVariants[i];
        break;
      }
    }
    if (variant) {
      btn.textContent = 'Add to cart - £50';
      btn.disabled = false;
      btn.dataset.variantId = variant.id;
    } else {
      btn.textContent = 'Out of stock';
      btn.disabled = true;
    }
  }

  // Add to Cart
  var addToCartBtn = document.getElementById('add-to-cart-btn');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (addToCartBtn.disabled) return;
      var variantId = addToCartBtn.dataset.variantId;
      if (!variantId) return;
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        addToCartBtn.textContent = 'Added!';
        setTimeout(function() {
          addToCartBtn.disabled = false;
          window.location.href = '/cart';
        }, 1000);
      })
      .catch(function() {
        addToCartBtn.textContent = 'Error - try again';
        addToCartBtn.disabled = false;
      });
    });
  }

  // Thumbnail click
  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.thumb');
    if (!thumb) return;
    var colour = thumb.dataset.colour;
    var index = thumb.dataset.index;
    document.querySelectorAll('.thumb[data-colour="' + colour + '"]').forEach(function(t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
    document.querySelectorAll('.gallery-img[data-colour="' + colour + '"]').forEach(function(img) {
      if (img.dataset.index === index) {
        img.classList.remove('hidden');
      } else {
        img.classList.add('hidden');
      }
    });
  });

  // Colour swatch toggle
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.swatch[data-colour]');
    if (!swatch) return;
    currentColour = swatch.dataset.colour;
    document.querySelectorAll('.swatch[data-colour]').forEach(function(s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');
    var nameEl = document.querySelector('.product-feature__colour-name');
    if (nameEl) {
      nameEl.textContent = currentColour.charAt(0).toUpperCase() + currentColour.slice(1);
    }
    document.querySelectorAll('.gallery-img').forEach(function(img) {
      img.classList.add('hidden');
    });
    var firstImg = document.querySelector('.gallery-img[data-colour="' + currentColour + '"]');
    if (firstImg) firstImg.classList.remove('hidden');
    document.querySelectorAll('.thumb').forEach(function(t) {
      if (t.dataset.colour === currentColour) {
        t.classList.remove('hidden');
      } else {
        t.classList.add('hidden');
      }
    });
    document.querySelectorAll('.thumb[data-colour="' + currentColour + '"]').forEach(function(t) {
      t.classList.remove('active');
    });
    var firstThumb = document.querySelector('.thumb[data-colour="' + currentColour + '"]');
    if (firstThumb) firstThumb.classList.add('active');
    var placeholder = document.getElementById('product-placeholder');
    if (placeholder) {
      placeholder.className = 'product-feature__media-placeholder ' + currentColour;
    }
    updateAddToCart();
  });

  // Size guide popup
  var sizeGuideBtn = document.getElementById('size-guide-btn');
  var sizeGuideOverlay = document.getElementById('size-guide-overlay');
  var sizeGuideClose = document.getElementById('size-guide-close');

  if (sizeGuideBtn) {
    sizeGuideBtn.addEventListener('click', function() {
      sizeGuideOverlay.style.display = 'flex';
    });
  }

  if (sizeGuideClose) {
    sizeGuideClose.addEventListener('click', function() {
      sizeGuideOverlay.style.display = 'none';
    });
  }

  if (sizeGuideOverlay) {
    sizeGuideOverlay.addEventListener('click', function(e) {
      if (e.target === sizeGuideOverlay) {
        sizeGuideOverlay.style.display = 'none';
      }
    });
  }

});